import { gsap } from 'gsap';
import { useEffect } from 'react';

import { setAnimationToIllustrationsPaths } from '@components/Sections/utils/animations';

import {
  StyledBoom,
  StyledDontGiveUp,
  StyledItsReallyRewarding,
  StyledRock,
  StyledSmile,
  StyledThosePeopleWho,
} from './IllustrationPens.styled';

export const IllustrationPens: React.FC = () => {
  useEffect(() => {
    const ctx = gsap.context(() => {
      setAnimationToIllustrationsPaths({
        illustration: '.boom path',
        trigger: '.boom',
        startPosition: 'bottom 90%',
      });
      setAnimationToIllustrationsPaths({
        illustration: '.dont-give-up path',
        trigger: '.dont-give-up',
        startPosition: 'bottom 90%',
      });
      setAnimationToIllustrationsPaths({
        illustration: '.those-peopl-who path',
        trigger: '.those-peopl-who',
        startPosition: 'bottom 90%',
      });
      setAnimationToIllustrationsPaths({
        illustration: '.its-really-rewarding path',
        trigger: '.its-really-rewarding',
        startPosition: 'bottom 90%',
        delay: 0.65,
      });
      setAnimationToIllustrationsPaths({
        illustration: '.rock path',
        trigger: '.rock',
        startPosition: 'bottom 90%',
        delay: 0.125,
      });
      setAnimationToIllustrationsPaths({
        illustration: '.smile path',
        trigger: '.smile',
        startPosition: 'bottom 90%',
        delay: 0.125,
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <>
      <StyledBoom className="boom" role="presentation" aria-hidden />
      <StyledItsReallyRewarding className="its-really-rewarding" aria-label="it's really rewarding" />
      <StyledThosePeopleWho
        className="those-peopl-who"
        aria-label="those people who are writing hurtful things to me — I win against them!"
      />
      <StyledRock className="rock" role="presentation" />
      <StyledDontGiveUp className="dont-give-up" aria-label="don't give up" />
      <StyledSmile className="smile" role="presentation" aria-hidden />
    </>
  );
};
